<template>
    <div>
        <div style="display: flex; flex-direction: row">
            <v-autocomplete :readonly="readonly" @update:search-input="SearchPresupuesto" v-model="id_presupuesto"
                :items="presupuestos" item-text="id" item-value="id" :label="label" :outlined="outlined"
                @change="(val) => $emit('change', val)">
                <template v-slot:append-item>
                    <div v-intersect="endIntersect" />
                </template>
            </v-autocomplete>
        </div>
    </div>
</template>
<script>
import { debounce } from "../../helpers";

export default {
    props: [
        "value",
        "extra",
        "label",
        "item-text",
        "enabled",
        "outlined",
        "rol",
        "readonly"
    ],
    data() {
        return {
            creado: null,
            rules: {
                email: (value) => {
                    const pattern =
                        /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
                    return pattern.test(value) || "E-mail inválido.";
                },
                fiscal: (value) => {
                    const pattern = /^[A-Z]+$/i;
                    return pattern.test(value) || "E-mail inválido.";
                },
            },
            id_presupuesto: null,
            presupuesto: {},
            dialog: false,
            users: [],
            update: false,
        };
    },
    watch: {
        value(val) {
            this.id_presupuesto = val;
        },
        id_presupuesto(val) {
            this.$emit("input", val);
        },
    },
    methods: {
        SearchPresupuesto: debounce(function (val) {
            this.$store.dispatch("searchPresupuesto", {
                rol: this.rol,
                search: val,
            });
        }, 500),
        endIntersect(entries, observer, isIntersecting) {
            if (isIntersecting) {
                this.$store.dispatch("getPresupuestosNext", { rol: this.rol });
            }
        },
    },
    mounted() {
        this.$store.dispatch("getPresupuestos", { rol: this.rol });
        if (this.value != null) {
            this.id_presupuesto = this.value;
        }
    },
    computed: {
        presupuestos() {
            ///console.log("siva");
            let presupuestos_temp = this.$store.getters.getpresupuestos;
            if (this.extra != null) {
                presupuestos_temp.push(this.extra);
            }
            if (this.creado) {
                presupuestos_temp.push(this.creado);
            }
            console.log(presupuestos_temp);
            return presupuestos_temp;
        },
    },
};
</script>
